/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Ares_LookupInputs */

const cs_auth_signup_ares_lookup = /** @type {(inputs: Auth_Signup_Ares_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst z ARES`)
};

const en_auth_signup_ares_lookup = /** @type {(inputs: Auth_Signup_Ares_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load from ARES`)
};

/**
* | output |
* | --- |
* | "Load from ARES" |
*
* @param {Auth_Signup_Ares_LookupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_ares_lookup = /** @type {((inputs?: Auth_Signup_Ares_LookupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Ares_LookupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_ares_lookup(inputs)
	return cs_auth_signup_ares_lookup(inputs)
});